window.addEventListener('DOMContentLoaded', (() => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const accordionId = urlParams.get('open');

  const accordion = document.querySelector(`[data-programid="${accordionId}"]`);
  if (accordion) {
    accordion.classList.add('is-open');
    const accordionContent = accordion.querySelector('.program-accordion__content-wrapper');
    accordion.querySelectorAll('.program-accordion__content-wrapper');
    accordionContent.setAttribute('style', 'box-sizing: border-box; display: block');

    const scrollToOpenAccordion = () => {
      const element = document.querySelector(`[data-programid="${accordionId}"]`);
      const headerOffset = document.querySelector('header').offsetHeight;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition - headerOffset - 20;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    };
    scrollToOpenAccordion();
  }
}));
